import styled from 'styled-components';

export const TooltipContainer = styled.span`
    position: relative;
    font-weight: normal;

    &.help {
        cursor: help;
    }

    .tooltip-text-wrapper {
        z-index: 10;
        display: none;
        padding: 14px 20px;
        left: 85px;
        bottom: -37px;
        width: 240px;
        height: 94px;
        line-height: 16px;
        position: absolute;
        -moz-border-radius: 4px;
        -webkit-border-radius: 4px;
        border-radius: 4px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.13);
        color: ${props => props.theme.black};
        border: 1px solid ${props => props.theme.lightGrey};
        background: ${props => props.theme.white};

        &:after,
        &:before {
            position: absolute;
            content: '';
            width: 0;
            height: 0;
            left: 0;
            top: 37px;
            border-style: solid;
            border-width: 11px;
            border-image: none 100% / 1 / 0 stretch;
            rotate: 180deg;
        }
        :before {
            border-color: transparent transparent transparent ${props => props.theme.lightGrey};
            margin-left: -22px;
        }
        &:after {
            border-color: transparent transparent transparent ${props => props.theme.white};
            margin-left: -21px;
        }
    }

    &.hover:hover {
        .tooltip-text-wrapper {
            display: inline;
        }
    }

    &.show {
        .tooltip-text-wrapper {
            display: inline;
        }
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        .tooltip-text-wrapper {
            left: -255px;
            bottom: -37px;

            &:after,
            &:before {
                rotate: 0deg;
            }
            :before {
                margin-left: 239px;
            }
            &:after {
                margin-left: 238px;
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/tooltip/TooltipStyle.js